<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    :hide-overlay="$vuetify.breakpoint.smAndDown"
  >

    <v-btn
      slot="activator"
      color="green accent-3"
      block
      dark
      :small="$vuetify.breakpoint.smAndDown"
    >
      Anna palautetta
    </v-btn>

    <v-card class="more-info-card">
      <v-card-title class="headline pb-0">
        <v-layout>
          <v-flex class="pt-1">
            Anna palautetta
          </v-flex>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="dialog = false"
          >
            <v-icon color="grey">close</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-card-text>

        <typeform v-if="dialog" @done="dialog = false"></typeform>

      </v-card-text>
      <!--
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn>
        <v-btn color="green darken-1" flat @click="dialog = false">Agree</v-btn>
      </v-card-actions>
      -->
    </v-card>
  </v-dialog>
</template>
<style lang="stylus" scoped>

  @import '~vuetify/src/stylus/settings/_variables.styl'

  .more-info-card
    h3
      font-weight 500
      font-size 1.4em
      color: $green.accent-3

</style>
<script>

  import Typeform from './Typeform'

  export default {

    components: {
      Typeform,
    },

    data: () => ({
      dialog: false,
    }),

  }

</script>